import { FinanceSettingsLineItems } from './FinanceSettingsLineItems.tsx';
import { useTranslation } from 'react-i18next';
import { FinanceSettingsHeader } from '@/shared/forms/FinanceSettingsForm/components/FinanceSettingsHeader.tsx';
import { FinanceSettingsOrganization } from '@/shared/forms/FinanceSettingsForm/domain/groupLineItemsByOrganization.ts';

type FinanceSettingsTransportExchangeProps = {
    organization: FinanceSettingsOrganization;
};

export function FinanceSettingsTransportExchange({ organization }: FinanceSettingsTransportExchangeProps) {
    const { t } = useTranslation();

    return (
        <article className="flex w-full flex-col gap-4 pb-6 last:pb-0">
            <FinanceSettingsHeader
                label={t('forms.inputs.partnerSelectionInput.transportExchange')}
                totalAmountNet={organization.totalAmountNet}
                includedProductCategories={organization.includedProductCategories}
            />
            <FinanceSettingsLineItems lineItems={organization.lineItems} />
        </article>
    );
}
